export class WorkspaceStorageAccessConfiguration {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "WorkspaceAwsStorageAccessConfiguration",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "WorkspaceGcpStorageAccessConfiguration",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceStorageAccessConfiguration.attributeTypeMap;
    }
    constructor() {
    }
}
